module.exports = __webpack_public_path__ + "static/media/arrowRight.2b75f3fb.svg";